var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo, useCallback } from "react";
var makeColor = function (_a) {
    var _b = _a.defaultColor, defaultColor = _b === void 0 ? "inputBorder" : _b, _c = _a.success, success = _c === void 0 ? "success" : _c, _d = _a.error, error = _d === void 0 ? "error" : _d, _e = _a.disabled, disabled = _e === void 0 ? "inputBorder" : _e;
    return ({
        success: success,
        error: error,
        disabled: disabled,
        default: defaultColor,
    });
};
var useInputStyles = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "large" : _b, disabled = _a.disabled, success = _a.success, error = _a.error, focused = _a.focused;
    var status = success ? "success" : error ? "error" : disabled ? "disabled" : "default";
    var sizeStyles = useMemo(function () {
        switch (size) {
            case "tiny":
                return {
                    height: "30px",
                    padding: [1, 2],
                };
            case "small":
                return {
                    height: "34px",
                    padding: [2, 3],
                };
            default: {
                return {
                    height: "42px",
                    padding: [2.5, 4],
                };
            }
        }
    }, [size]);
    var inputContainer = useMemo(function () {
        return __assign(__assign({ width: "100%" }, sizeStyles), { background: disabled ? "mainBackgroundDisabled" : "mainBackground", border: {
                size: "1px",
                type: "solid",
                color: focused
                    ? makeColor({ defaultColor: "inputBorderFocus" })[status]
                    : makeColor({})[status],
                side: "all",
            }, round: true, _hover: {
                border: {
                    size: "1px",
                    type: "solid",
                    color: makeColor({ defaultColor: "inputBorderHover" })[status],
                    side: "all",
                },
            } });
    }, [status, sizeStyles, focused]);
    var iconContainer = useCallback(function (_a) {
        var _b = _a.iconRight, iconRight = _b === void 0 ? false : _b, _c = _a.iconLeft, iconLeft = _c === void 0 ? false : _c;
        return {
            height: "100%",
            background: disabled ? "mainBackgroundDisabled" : "mainBackground",
            alignItems: "center",
            round: true,
            margin: [0, iconRight ? 0 : 2.5, 0, iconLeft ? 0 : 2.5],
        };
    }, [disabled]);
    return { styles: { inputContainer: inputContainer, iconContainer: iconContainer } };
};
export default useInputStyles;
